import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './content/en.json';
import pl from './content/pl.json';

// To add a language: put de.json next to en.json, register it here and add it to LANGUAGES.
const resources = { en: { translation: en }, pl: { translation: pl } };
export type Language = keyof typeof resources;
/** Languages offered in the header switch, in display order. */
export const LANGUAGES: Language[] = ['pl', 'en'];

const STORAGE_KEY = 'dg-lang';
const isLanguage = (v: string | null | undefined): v is Language => !!v && v in resources;

function stored(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

/** The visitor's own choice first; otherwise English unless the browser prefers a language we have. */
function detectLanguage(): Language {
  const saved = stored();
  if (isLanguage(saved)) return saved;
  const preferred = (navigator.languages?.[0] ?? navigator.language ?? 'en').toLowerCase().split('-')[0];
  return isLanguage(preferred) ? preferred : 'en';
}

const lng = detectLanguage();
document.documentElement.lang = lng;

void i18n.use(initReactI18next).init({
  resources,
  lng,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

/** Switches the panel language and remembers the choice in this browser. */
export function setLanguage(next: Language) {
  try {
    localStorage.setItem(STORAGE_KEY, next);
  } catch {
    // Private mode etc.: the choice just lasts for this visit.
  }
  document.documentElement.lang = next;
  void i18n.changeLanguage(next);
}

export default i18n;
